import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { ButtonLink, MiniCalendar } from 'dyl-components';
import { Header, Icon, Dropdown, Button, Popup } from 'semantic-ui-react';
import oauthActions from 'actions/oauth';
import OptionDrawer from './optionDrawer';

import './index.scss'

const LeftPanel = ({ miniDate, handleMiniChange, options, allOptions, openAddActivityModal, addActivityAction, onChangeAllOptions, onChangeOptions, user_id }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const { calendar_integrations = [] } = useSelector(state => state.oauth_integrations);

    useEffect(() => {
        dispatch(oauthActions.getCalendarIntegrations({ scopes: 'calendar', include_disabled: false }));
    }, [dispatch]);

    const goToIntegrations = () => {
        const integrationURI = `/settings/users/${user_id}/integration`;
        navigate(integrationURI);
    }

    const hasIntegrations = calendar_integrations && calendar_integrations.length > 0;
    const mainIntegration = calendar_integrations.find(integration => integration.scopes.some(scope => scope.main && scope.scope_type === 'calendar')) || { name: '', email: '' };
    return (
        <>
            <div className="LeftPanel__Container">
                <div className="LeftPanel__MiniContainer">
                    <MiniCalendar value={miniDate} onChange={handleMiniChange} markToday>
                        <Dropdown
                            as={Button}
                            floating
                            options={[
                                { key: 0, value: 'task', text: 'Task', icon: 'fa-solid fa-clipboard-check' },
                                { key: 1, value: 'event', text: 'Event', icon: 'fa-solid fa-calendar-day' },
                            ]}
                            onChange={(_, { value }) => { openAddActivityModal(value) }}
                            color='primary'
                            text={<span><Icon name='plus' size='tiny' /> New </span>}
                            value={addActivityAction}
                            selectOnBlur={false}
                            className="AddActivityButton"
                            size="small"
                        />
                    </MiniCalendar>
                </div>
                <div className="LeftPanel__BottomContainer">
                    <div className="MyCalendar">
                        <div className="MyCalendar__Container">
                            <Icon name="calendar check" size="large" />
                            <Header as={'h4'} className="LeftPanel__Header">My Calendar</Header>
                        </div>
                        <div className="MyCalendar__Integration">
                            {hasIntegrations && mainIntegration ? (
                                <Popup
                                    trigger={
                                        <ButtonLink onClick={goToIntegrations}>
                                            Update Integration
                                        </ButtonLink>
                                    }
                                    position='bottom center'
                                    basic
                                    flowing
                                    hoverable
                                    content={(
                                        <div>
                                            <Header as="h4">{mainIntegration.name}</Header>
                                            {mainIntegration.email}
                                        </div>
                                    )}
                                />
                            ) : (
                                <ButtonLink onClick={goToIntegrations}>
                                    Set up integration
                                </ButtonLink>
                            )}
                            
                        </div>
                    </div>
                    <div>
                        <OptionDrawer options={options} allOptions={allOptions} onChangeAllOptions={onChangeAllOptions} onChangeOptions={onChangeOptions} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default LeftPanel;
